import React, {useEffect, useState} from 'react';
import {useFormik} from 'formik';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import _ from 'lodash';
import './ResetPass.scss';
import {useHistory, useParams, useRouteMatch} from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {IconButton, InputAdornment} from '@material-ui/core';
import {Input} from '@mui/material';
import CustomInput from '../../../common/components/CustomInput/CustomInput';
import Button from "../../../common/components/Button/Button";

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.touched, name ) && _.get( formik.errors, name ) }
        </div>
    );
};

const _ResetPass = ({resetPass, logout, resetPasswordState, cleanResetPassState, showSidebar}) => {
    const {token} = useParams();
    const isFirstTime = useRouteMatch('/set-password/:token');
    const history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);

    useEffect(() => {
        logout();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (resetPasswordState?.success) {
            history.replace('/login');
            cleanResetPassState();
        }
        // eslint-disable-next-line
    }, [resetPasswordState?.success]);

    const validationSchema = yup.object({
        pass: yup
            .string('Ingrese contrasena')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*["#@$!%*?&._+=-])[A-Za-z0-9\\d"#@$!%*?&._+=-]{8,}$/,
                'Debe tener 8 caracteres, con minuscula, mayuscula, numero y caracter especial')
            .required('Ingrese contrasena'),
        repass: yup
            .string('Ingrese confirmacion')
            .oneOf([yup.ref('pass'), null], 'Las contrasenas no coinciden')
            .required('Ingrese confirmacion'),
    });
    const formik = useFormik({
        initialValues: {
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                token: token,
                newPassword: values.pass,
            };
            resetPass(body);
            },
    });

    return (
        <div className="set-pass-container">

            <p className="h3 v2-c-text-title set-pass-title">Cambiar contraseña</p>

            <form className="set-pass-form" onSubmit={formik.handleSubmit}>
                <div className="set-pass-form-inputs-container">
                    <div className="set-pass-input">
                        <CustomInput
                            label="Nueva contraseña"
                            type={showPassword ? 'text' : 'password'}
                            onChange={(value) => formik.handleChange({target: {name: 'pass', value}})}
                            value={formik.values.pass}
                            placeholder="Ingrese su contraseña"
                            rightSlot={<InputAdornment style={{marginRight: '-15px'}}>
                                <IconButton>
                                    {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                                </IconButton>
                            </InputAdornment>}
                            rightSlotOnClick={() => setShowPassword(!showPassword)}
                        />
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='pass' className='rp-input-l'/>
                        </div>
                    </div>

                    <div className="set-pass-input">
                        <CustomInput
                            label="Repetir contraseña"
                            type={showRePassword ? 'text' : 'password'}
                            onChange={(value) => formik.handleChange({target: {name: 'repass', value}})}
                            value={formik.values.repass}
                            placeholder="Ingrese su contraseña"
                            rightSlot={<InputAdornment style={{marginRight: '-15px'}}>
                                <IconButton>
                                    {showRePassword ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                                </IconButton>
                            </InputAdornment>}
                            rightSlotOnClick={() => setShowRePassword(!showRePassword)}
                        />
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='repass' className='rp-input-l'/>
                        </div>
                    </div>
                </div>
                <div className={'submit-set-pass-button'}>
                    <Button size={'medium'} type="submit">Cambiar</Button>
                </div>
            </form>
        </div>
    );
};

const mapStateToProps = (state) => ({
    resetPasswordState: state.login.resetPasswordState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    resetPass: (body) => dispatch(actions.login.resetPassRequest(body)),
    logout: () => dispatch(actions.login.logout()),
    cleanResetPassState: () => dispatch(actions.login.cleanResetPassState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(_ResetPass);
